import ResultsDtoBaseModel from "models/ResultsDtoBaseModel"

export interface ResultsDtoModel<T> extends ResultsDtoBaseModel {
    items: T[];
}

export const initialResultsDtoModel = {
    items: [],
    totalResults: 0,
    page: 0,
    offset: 0
}